import { documentService, type DocumentDto } from "../../../services/documentService";

/**
 * Ein Dokument aus KMVS als `File` — für alles, was eine Datei erwartet.
 *
 * „Datei scannen" liest Visitenkarte, Ausweis und Gehaltsabrechnung aus einer
 * Datei vom Rechner. Liegt der Beleg schon in KMVS (etwa der Ausweis-Scan,
 * den ein Kollege zur Legitimation abgelegt hat), führte der einzige Weg
 * dorthin bis zum 22.09.2026 über das Herunterladen, um ihn gleich wieder
 * auszuwählen.
 *
 * GESPEICHERT WIRD NICHTS: Das Dokument bleibt, wo es ist; hier entsteht nur
 * eine Kopie im Arbeitsspeicher, die denselben Weg geht wie eine ausgewählte
 * Datei. Die Auswertung lädt danach weder hoch noch löscht sie (§ 20 PAuswG,
 * siehe Kopf von `DateiScannenDialog.tsx`).
 *
 * Der `mimeType` kommt aus dem Dokument, ersatzweise aus der Antwort: Ein
 * Teil des Bestands (Import der Alten Kundenakte) trägt gar keinen, und die
 * Formatprüfung der Leser hinge sonst an einem leeren Typ.
 */
export const dokumentAlsDatei = async (
    doc: Pick<DocumentDto, "id" | "fileName" | "mimeType">,
    ladeBlob: (id: number) => Promise<Blob> = documentService.fetchBlob,
): Promise<File> => {
    const blob = await ladeBlob(doc.id);
    return new File([blob], doc.fileName, { type: doc.mimeType || blob.type });
};
